import { styled } from "styled-components";
import Text from "~/components/Text";

export const StyledProductMeta = styled(Text)`
  margin-bottom: ${({ theme }) => theme.space[8]};
`;
